module.exports = __webpack_public_path__ + "img/product_bg_02.2c8e8a6.png";